import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import RegisterPage from './pages/RegisterPage';
import CompanyRequestPage from './pages/CompanyRequestPage';
import CompanyPage from './pages/CompanyPage';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<CompanyPage />} />
        <Route path="/company" element={<CompanyPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/company-request" element={<CompanyRequestPage />} />
      </Routes>
    </Router>
  );
}

export default App;